module.exports = __webpack_public_path__ + "media/assets/images/landings/workforce/screens/workforce_report_overview-e06da96662dda994a62bd41c72f688f3.png";